import { Injectable } from '@angular/core';
import {DropdownOption} from "./model/DropdownOption";

@Injectable({
    providedIn: 'any'
})
export class TfDropdownService {

  constructor() { }

  filterBySearch(optionsArray, optionKey: string, filterValue: string) {
    const filteredOptions: any = [];
    const filterQuery = filterValue.trim().toLowerCase();
    if (optionsArray && optionsArray.length > 0) {
      for (const option of optionsArray) {
        if ((optionKey && (option[optionKey].trim().toLowerCase()).indexOf(filterQuery) !== -1) || (!optionKey && (option.trim().toLowerCase()).indexOf(filterQuery) !== -1)) {
          filteredOptions.push(option);
        }
      }
    }
    return filteredOptions;
  }

  isArrayOfStringType(array:any[]): boolean {
    if (array instanceof Array) {
      for (const item of array) {
        if(typeof item !== 'string') {
          return false
        }
      }
      if(array.length > 0) {
        return true
      }
    }
    return false;
  }

  convertStringArrayToArrayOfObjects(options, key:string = 'label') {

    return options.map(option => {
      const object: DropdownOption = {
        value: option,
        disabled: false
      };
      object[key] = option;

      return object;
    })
  }
}
